import { color, Link, media, radius, spacing, typography } from '@gyym/ui'
import styled, { css } from 'styled-components'

export const Container = styled.footer<{ hideTabletFooter: boolean }>`
  margin-top: auto;

  ${({ hideTabletFooter }) =>
    hideTabletFooter &&
    css`
      display: none;

      ${media.pc} {
        display: block;
      }
    `}
`

export const NavList = styled.ul`
  text-align: left;
  max-width: auto;
  margin: 0;

  ${media.tablet} {
    text-align: center;
    max-width: 480px;
    margin: 0 auto;
  }
`

export const NavListItem = styled.li`
  ${typography('caption1')};
  display: inline-block;
  margin-right: ${spacing(2)};

  ${media.tablet} {
    margin-left: ${spacing(3)};

    &:last-child {
      margin-right: 0;
    }
  }

  & > a {
    color: ${color('gray.02')};
    transition: color 0.2s ease;

    &:hover {
      color: ${color('red.01')};
    }
  }
`

export const CircleIconButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${color('gray.04')};
  border: 1px solid ${color('gray.04')};
  border-radius: ${radius('full')};
  height: 42px;
  width: 42px;
  margin-left: ${spacing(3)};

  &:hover {
    opacity: 0.75;
  }

  &:first-child {
    margin-left: 0;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  border-top: 1px solid ${color('gray.04')};
`

export const Copyright = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  background: ${color('gradient.primary')};
`
